import * as React from 'react';
import { RegisterOptions, UseFormReturn } from 'react-hook-form';
import { Input } from '../../../components/forms/Input';
import { FormModal } from '../../../components/containers/FormModal';
import { SubmitHandler } from 'react-hook-form/dist/types/form';
import { InputTypes } from '../../../constants/form';

export type NameEmailModalViewProps = {
  onClose: () => void;
  onSubmit: SubmitHandler<{ name: string; email: string }>;
  submitted: boolean;
  useFormInstance: UseFormReturn;
  nameRules: RegisterOptions;
  emailRules: RegisterOptions;
};

export const NameEmailModalView = (props: NameEmailModalViewProps): JSX.Element => (
  <FormModal
    closeOnClickOutside
    onClose={props.onClose}
    showCloseIcon={!props.submitted}
    formInstance={props.useFormInstance}
    loading={props.submitted}
    onSubmit={props.onSubmit}
    submitText={'Save'}
    title={'Edit Name & Email'}>
    <div className={`padding-bottom-small-20`}>
      <Input
        disabled={props.submitted}
        formInstance={props.useFormInstance}
        name={'name'}
        type={InputTypes.text}
        size={'large'}
        label={`Full Name`}
        rules={props.nameRules}
      />
    </div>
    <div>
      <Input
        disabled={props.submitted}
        formInstance={props.useFormInstance}
        name={'email'}
        type={InputTypes.email}
        size={'large'}
        label={`Email`}
        rules={props.emailRules}
      />
    </div>
  </FormModal>
);
